import {
  Arrange,
  Button,
  Container,
  IconButton,
  Spacer,
  SvgClose,
  Text,
} from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import * as analytics from 'utilities/analytics';
import { isIOS } from 'utilities/device';

import useMedia from 'hooks/useMedia';
import appIcon from 'img/logos/app-icon.svg';

import {
  CLICKED_ANDROID_DOWNLOAD_APP,
  CLICKED_IOS_SHARE_DOWNLOAD_APP,
} from '../../../constants/events';
import { MOBILE_ANDROID_APP, MOBILE_IOS_APP } from '../../../constants/routes';

import styles from './styles.module.less';

const MobileAppCard = ({ onCloseClick }) => {
  const href = isIOS ? MOBILE_IOS_APP : MOBILE_ANDROID_APP;

  const tracking = isIOS
    ? CLICKED_IOS_SHARE_DOWNLOAD_APP
    : CLICKED_ANDROID_DOWNLOAD_APP;

  const headingSize = useMedia(['(min-width: 360px)'], ['large'], 'medium');

  return (
    <>
      <div className={classNames(styles.mobileAppCardWrapper, 'theme-dark')}>
        <Spacer
          x="medium"
          y={{
            default: 'small',
            '360px': 'medium',
          }}
        >
          <Arrange gap="small" justifyContent="space-between">
            <Text
              color="body"
              fontWeight="bold"
              size={headingSize}
              htmlTag="h2"
            >
              Record, share, and watch on the go
            </Text>
            <IconButton
              altText="Close"
              icon={<SvgClose />}
              onClick={onCloseClick}
            />
          </Arrange>
        </Spacer>
        <Container padding="medium" borderSide="top">
          <Arrange gap="4" autoFlow="row" justifyContent="stretch">
            <Arrange justifyContent="space-between">
              <Arrange gap="medium">
                <img
                  alt=""
                  className={classNames(
                    isIOS ? 'radius:medium' : styles.androidIcon,
                    'border'
                  )}
                  src={appIcon}
                  height="48"
                  width="48"
                />
                <Text color="body" fontWeight="bold">
                  Loom App
                </Text>
              </Arrange>
              <Button
                htmlTag="a"
                href={href}
                variant="primary"
                onClick={e => {
                  e.preventDefault(); // prevent using href on click, but we keep the href to still allow right-click to copy link
                  analytics.track(tracking);
                  window.location.href = href;
                }}
                hasFullWidth
                target="_blank"
                rel="noopener"
              >
                Download
              </Button>
            </Arrange>
          </Arrange>
        </Container>
      </div>
      <div className={styles.mobileAppCardSpacer} />
    </>
  );
};

export default MobileAppCard;
